import React from 'react';

const ArrowRight = ({
  isShadowOn = false,
  width = 28,
  height = 48,
  color = '#fff',
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 28 48"
  >
    {isShadowOn && (
    <defs>
      <filter id="shadowRight">
        <feDropShadow
          dx="0"
          dy="0"
          stdDeviation="3"
          floodColor="#00000029"
        />
      </filter>
    </defs>
    )}
    <path
      d="M27.242 26.019l-20.6 21.2a2.857 2.857 0 01-3.924 0L.756 45.201a3.075 3.075 0 010-4.038L17.432 24 .756 6.837a3.075 3.075 0 010-4.038L2.718.78a2.857 2.857 0 013.924 0l20.6 21.2a3.068 3.068 0 010 4.039z"
      fill={color}
      filter="url(#shadowRight)"
    />
  </svg>
);

export default ArrowRight;
